import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import clock from "../../assets/clock.png";
import user from "../../assets/users.png";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import GroupIcon from "@mui/icons-material/Group";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { format_Number } from "../../utils/utils";

const CombinationCard = ({
  data,
  selectedDate,
  reservType,
  adult,
  child,
  kid,
  baby,
  toddler,
  languageWords,
  totalCount,
}) => {
  const theme = useTheme();
  dayjs.extend(advancedFormat);
  const { combinationQTY, selectedCombination } = useSelector(
    (store) => store?.Activity
  );

  const { widgetConfig, resType } = useSelector(
    (store) => store?.widgetSettings
  );

  const originalDate = dayjs(selectedDate, "DD-MM-YYYY");

  const formatDateWithLanguage = (originalDate) => {
    const dayName = originalDate.format("dddd"); // Get the day name (e.g., "Thursday")
    const dayNumber = originalDate.format("DD"); // Get the day number (e.g., "11")
    const monthName = originalDate.format("MMMM"); // Get the month name (e.g., "November")
    const year = originalDate.format("YYYY"); // Get the year (e.g., "2024")

    // Translate day and month names using `languageWords`
    const translatedDayName = languageWords[dayName] || dayName;
    const translatedMonthName = languageWords[monthName] || monthName;

    // Construct the translated date string
    return `${translatedDayName} ${dayNumber} ${translatedMonthName} ${year}`;
  };

  const formattedDate = formatDateWithLanguage(originalDate);

  return (
    <Box
      sx={{
        //  border: `1px solid ${theme?.details?.detailsBorderColor}`,
        backgroundColor: theme?.palette?.background?.paper,
        //theme?.details?.detailsBgColor,
        borderRadius: "16px",
        mt: 2,
        mb: 2,
        p: 3,
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          color: theme?.details?.detailsHeaderColor,
          fontSize: { md: "24px", sm: "20px", xs: "16px" },
          fontWeight: "medium",
          mb: 1,
        }}
      >
        {data?.reservationType}
        <small
          style={{
            color: "#969BA0",
            fontSize: "10px",
            marginLeft: "0.6rem",
          }}
        >
          {data?.isBefore
            ? `${languageWords?.before || "Before"} ${reservType?.name}`
            : `${languageWords?.after || "After"} ${reservType?.name}`}
        </small>
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          alignItems: "center",
          mt: 2,
          mb: 2,
        }}
      >
        <Box sx={{ width: "24px", height: "24px" }}>
          <AccessTimeIcon
            sx={{
              width: "100%",
              height: "100%",
              color: theme?.details?.detailsDateIconColor,
            }}
          />
        </Box>
        <Box>
          {resType == "ticketing" ? (
            <Typography
              sx={{
                color: theme?.details?.detailsDateTextColor,
                fontSize: "14px",
              }}
            >
              {reservType?.isStandardTicket
                ? dayjs(selectedDate).format("DD-MM-YYYY")
                : selectedDate?.availableDate}
            </Typography>
          ) : (
            <Typography
              sx={{
                color: theme?.details?.detailsDateTextColor,
                fontSize: "14px",
              }}
            >
              {formattedDate}
            </Typography>
          )}

          <Typography
            sx={{
              color: theme?.details?.detailsDateTextColor,
              fontSize: "14px",
              fontWeight: "500", // Slightly bold for better emphasis
              display: "flex",
              justifyContent: "flex-start", // Centers the content horizontally
              alignItems: "center", // Aligns the text vertically
              gap: "0.5rem", // Adds space between "From" and "To"
              mt: 1,
            }}
          >
            {languageWords?.From}:{" "}
            <span
              style={{
                fontWeight: "bold",
                color: theme?.details?.detailsDateTextColor,
              }}
            >
              {data?.arrivalTime?.substring(0, 5)}
            </span>{" "}
            - {languageWords?.To}:{" "}
            <span
              style={{
                fontWeight: "bold",
                color: theme?.details?.detailsDateTextColor,
              }}
            >
              {data?.depatureTime?.substring(0, 5)}
            </span>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <Box sx={{ width: "24px", height: "24px" }}>
            <GroupIcon
              sx={{
                width: "100%",
                height: "100%",
                color: theme?.details?.detailsGuestsIconColor,
              }}
            />
          </Box>
          <Typography
            sx={{
              color: theme?.details?.detailsGuestsTextColor,
              fontSize: "14px",
            }}
          >
            {adult > 0 &&
              `${
               data.activitiesPriceType === "pricepertime" || !data.activitiesPriceType
                
                  ? combinationQTY?.[
                    data.idreservationtype + String(data.isBefore)
                  ]
                  : totalCount
              } ${data.activitiesPriceType === "pricepertime" ? 'lane' : widgetConfig?.fields?.field1Text || ""}`}
            {kid > 0 && `, ${kid} ${widgetConfig?.fields?.field3Text}`}
            {child > 0 && `, ${child} ${widgetConfig?.fields?.field2Text}`}
            {toddler > 0 && `, ${toddler} ${widgetConfig?.fields?.field5Text}`}
            {baby > 0 && `, ${baby} ${widgetConfig?.fields?.field4Text}`}
          </Typography>
        </Box>
        {/* <Box>
          {data?.price > 0 && (
            <Typography
              sx={{
                color: theme?.details?.detailsPriceColor,
                fontWeight: "medium",
                fontSize: "16px",
              }}
            >
              &euro;{format_Number(parseFloat(totalCount * data?.price).toFixed(2))}
            </Typography>
          )}
        </Box> */}
      </Box>

      {data?.price > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              color: theme?.details?.detailsReservationTypeTextColor,
              fontWeight: "bold",
            }}
          >
            {data?.reservationType}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              color: theme?.details?.detailsPriceColor,
              fontWeight: "bold",
            }}
          >
            €
            {format_Number(
              parseFloat(
                data?.price *
                  combinationQTY[data.idreservationtype + String(data.isBefore)]
              ).toFixed(2)
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CombinationCard;
